const navbar = document.getElementById('main-nav')

// OnScroll event handler
const onScroll = () => {

  // Get scroll value
  const scroll = document.documentElement.scrollTop

  // If scroll value is more than 0 - add class
  if (scroll > 0) {
    navbar.classList.remove("bg-with-margin");
  } else {
    navbar.classList.add("bg-with-margin")
  }

}

// Use the function
window.addEventListener('scroll', onScroll)

console.log(123)

document.addEventListener('DOMContentLoaded', function () {
  const heroPreload = document.querySelector('img.preload-hero')

  function loaded() {

    document.querySelector('.preload-hero-hide').classList.add('hideLoad')
    heroPreload.classList.add('loadHero')
  }


  setTimeout(function () {
    if (heroPreload) {
      heroPreload.src = heroPreload.dataset.src
      if (heroPreload.complete) {
        loaded()
      } else {
        heroPreload.addEventListener('load', loaded)
        heroPreload.addEventListener('error', function () {
          console.log('error load image')
        })
      }
    }
  }, 2000)
});
jQuery(document).ready(function ($) {
  $('.ajax-load-posts').click(function (e) {
    e.preventDefault()
    var button = $(this),
      data = {
        'action': 'grapevine_posts_loadmore',
        'query': grapevine_loadmore_params.posts, // that's how we get params from wp_localize_script() function
        'page': grapevine_loadmore_params.current_page
      };

    $.ajax({ // you can also use $.post here
      url: grapevine_loadmore_params.ajaxurl, // AJAX handler
      data: data,
      type: 'POST',
      beforeSend: function (xhr) {
        button.addClass('disabled'); // change the button text, you can also add a preloader image
      },
      success: function (data) {
        if (data) {
          console.log(button.prev())
          button.removeClass('disabled').parent().prev().after(data); // insert new posts
          grapevine_loadmore_params.current_page++;

          if (grapevine_loadmore_params.current_page == grapevine_loadmore_params.max_page)
            button.remove(); // if last page, remove the button

          // you can also fire the "post-load" event here if you use a plugin that requires it
          // $( document.body ).trigger( 'post-load' );
        } else {
          button.remove(); // if no data, remove the button as well
        }
      }
    });
  });
})